import { Checkmark } from 'react-checkmark';
import BookingFormScreen from './BookingFormScreen';
import FamilyDetailsScreen from './FamilyDetailsScreen';
import PageShell from './PageShell';
import ServicesScreen from './ServicesScreen';

const BookingSuccessScreen = ({ formSuccessMessage, windowSize }) => (
    <PageShell windowSize={windowSize}>
        <Checkmark />
        {formSuccessMessage && <p className="text-success text-center fs-5 p-3">{formSuccessMessage}</p>}
    </PageShell>
);

const HomePage = (controller) => {
    if (controller.isBookingSuccess) {
        return <BookingSuccessScreen formSuccessMessage={controller.formSuccessMessage} windowSize={controller.windowSize} />;
    }

    if (controller.isformOpen) {
        return <BookingFormScreen {...controller} />;
    }

    if (controller.displayCoupons) {
        return <ServicesScreen {...controller} />;
    }

    return (
        <FamilyDetailsScreen
            {...controller}
            onMemberSelect={controller.bookAppointment}
            onToggleCard={controller.toggleCardFlip}
        />
    );
};

export default HomePage;
